var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.startParser
    ? _c("GenerateForm", {
        ref: "GenerateForm",
        attrs: {
          "form-conf": _vm.formConf,
          "question-mode": false,
          pageSettingData: _vm.pageSettingData,
        },
      })
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }